import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { RegisterFormData } from '../../types';
import { GenderSelect, DatePicker, MaritalStatusSelect } from '../form-fields';
import { DateInfo } from '@/utils/date/types';

interface BasicInfoProps {
  form: UseFormReturn<RegisterFormData>;
}

export function BasicInfo({ form }: BasicInfoProps) {
  const { register, formState: { errors }, watch, setValue } = form;

  const handleDateChange = (date: DateInfo | undefined) => {
    setValue('birthDate', date);
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">البيانات الأساسية</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">الاسم *</Label>
          <Input
            id="name"
            {...register('name', { required: 'هذا الحقل مطلوب' })}
            placeholder="الاسم الكامل"
          />
          {errors.name && (
            <p className="text-sm text-red-500">{errors.name.message}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label>الجنس *</Label>
          <GenderSelect
            value={watch('gender') || ''}
            onChange={(value) => setValue('gender', value as 'male' | 'female')}
            error={errors.gender?.message}
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <DatePicker
              value={watch('birthDate')}
              onChange={handleDateChange}
              error={errors.birthDate?.message}
              showSwitchInLabel
              inlineSwitch
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label>الحالة الاجتماعية *</Label>
          <MaritalStatusSelect
            value={watch('maritalStatus') || ''}
            onChange={(value) => setValue('maritalStatus', value)}
            error={errors.maritalStatus?.message}
          />
        </div>
      </div>
    </div>
  );
}